import { render } from "./Introduction.vue?vue&type=template&id=1c0e6d9a&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1c0e6d9a"

export default script